import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ReferentielService } from '../../../../core/services/referentiel.service';
import { BannerComponent } from '../../../../shared/components/banner/banner.component';
import { SafeMapsComponent } from '../../../../shared/components/maps/safe-maps.component';
import {
  BuildingIcon,
  CalendarIcon,
  ClockIcon,
  LucideAngularModule,
  MailIcon,
  PhoneIcon,
  UserIcon,
  CircleIcon,
} from 'lucide-angular';
import { ThemeService } from '../../../../core/services/theme.service';

@Component({
  selector: 'app-pharmacie-details',
  standalone: true,
  imports: [
    CommonModule,
    BannerComponent,
    SafeMapsComponent,
    LucideAngularModule,
  ],
  templateUrl: './pharmacie-details.component.html',
  styleUrls: ['./pharmacie-details.component.scss'],
})
export class PharmacieDetailsComponent implements OnInit {
  pharmacy: any;
  loading = true;
  error: string | null = null;

  readonly UserIcon = UserIcon;
  readonly MailIcon = MailIcon;
  readonly PhoneIcon = PhoneIcon;
  readonly BuildingIcon = BuildingIcon;
  readonly ClockIcon = ClockIcon;
  readonly CalendarIcon = CalendarIcon;
  readonly CircleIcon = CircleIcon;

  bannnerLinks: { label: string; href?: string }[] = [];

  constructor(
    private route: ActivatedRoute,
    private referentielService: ReferentielService,
    private themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'];
      const country = params['country'];

      this.bannnerLinks = [
        { label: 'Portail Public', href: `/${country}/home` },
        { label: 'Pharmacies', href: `/${country}/pharmacies` },
        { label: 'Détails', href: undefined },
      ];

      this.loadPharmacyDetails(id);
    });
  }

  private loadPharmacyDetails(id: string): void {
    this.loading = true;
    this.referentielService.getPharmacyDetails(id).subscribe({
      next: (pharmacy) => {
        this.pharmacy = pharmacy;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading pharmacy details:', error);
        this.error = 'Error loading pharmacy details';
        this.loading = false;
      },
    });
  }

  // Nom du produit selon le thème (FA'JMA ou Passeport Médical)
  getProductName(): string {
    return this.themeService.getProductName();
  }
}
